import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";

import { ChakraProvider } from "@chakra-ui/react";
import { system } from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ChakraProvider value={system}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
